import type { SceneBuilder } from "../../reel/scenes.js";
import { brandBackdrop } from "../../primitives/brandBackdrop.js";
import {
  accentFor, clipOutroFade, combineSceneFragments, makeTl, typeSize, weights,
  colors as themeColors, escapeHtml, gsapSetLine,
} from "../../reel/sceneShared.js";

export const splitHero: SceneBuilder = ({ ctx, clipPrefix, inputs, clipDurationSec, clipStartSec }) => {
  const text = inputs.text ?? "";
  const tokens = text.split(/(\s+)/);
  const midIdx = Math.floor(tokens.length / 2);
  const left = tokens.slice(0, midIdx).join("").trim();
  const right = tokens.slice(midIdx).join("").trim();

  const accent = accentFor(inputs);
  const hero = typeSize("hero", ctx.format);
  const t = makeTl(clipStartSec);
  const lId = `${clipPrefix}-l`;
  const rId = `${clipPrefix}-r`;
  const wrapId = `${clipPrefix}-wrap`;

  const backdrop = brandBackdrop(ctx, `${clipPrefix}-bg`, { variant: "split", accent });

  const isVertical = ctx.format === "9:16";
  const baseStyle = `font-family:'Outfit',sans-serif;font-weight:${weights.black};font-size:${hero}px;line-height:.95;letter-spacing:-3.5px;flex:1;`;

  const html = `<div id="${wrapId}" class="clip" data-start="${clipStartSec.toFixed(4)}" data-duration="${clipDurationSec.toFixed(4)}" style="position:absolute;inset:0;display:flex;flex-direction:${isVertical ? "column" : "row"};align-items:center;justify-content:center;gap:40px;padding:96px;">
  <div id="${lId}" style="${baseStyle}color:${themeColors.fg};text-align:right;">${escapeHtml(left || text)}</div>
  ${right ? `<div id="${rId}" style="${baseStyle}color:${themeColors.primary};text-align:left;">${escapeHtml(right)}</div>` : ""}
</div>`;

  const init = [
    gsapSetLine(`#${lId}`, { x: -180, opacity: 0 }),
    right ? gsapSetLine(`#${rId}`, { x: 180, opacity: 0 }) : "",
  ].filter(Boolean).join("\n");

  const tweens = [
    t.to(`#${lId}`, { x: 0, opacity: 1, duration: 0.93, ease: "raw:\"power2.out\"" }, 0),
  ];
  if (right) tweens.push(t.to(`#${rId}`, { x: 0, opacity: 1, duration: 0.93, ease: "raw:\"power2.out\"" }, 0));
  tweens.push(clipOutroFade(clipPrefix, clipDurationSec, clipStartSec));

  return combineSceneFragments([backdrop, { html, init, tweens }]);
};
